__turbopack_context__.v({
  "carousel": "xag8aq_carousel",
  "controlsArea": "xag8aq_controlsArea",
  "dot": "xag8aq_dot" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "dotActive": "xag8aq_dotActive",
  "dots": "xag8aq_dots",
  "dotsWrapper": "xag8aq_dotsWrapper",
  "insideControls": "xag8aq_insideControls",
  "navButton": "xag8aq_navButton",
  "nextButton": "xag8aq_nextButton",
  "prevButton": "xag8aq_prevButton",
  "slidesWrapper": "xag8aq_slidesWrapper",
  "viewport": "xag8aq_viewport",
});
